import react, { useEffect, useState } from "react";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";
import { Btn } from "../../../../AbstractElements";
import RouteDropdown from "../../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import {

  useAddOutletOrgNote,
  useOutletOrgNoteByID,
  useUpdateOutletOrgNote,
} from "../hooks/useCustomer";
import PaginatedRouteDropdown from "../../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getTownFilter } from "../hooks/CustomerRepository";

interface prop {
  mode: "add" | "edit";
  modalClose: () => void;
  initialData?: Record<string, any>;
  OutletOrgId:any
}

const InternalNoteModal: React.FC<prop> = ({ mode, modalClose, initialData,OutletOrgId }) => {
  const [date, setDate] = useState();
  const [title, setTitle] = useState();
  const [note, setNote] = useState();

  const {data:getNoteById}=useOutletOrgNoteByID({
    enabled:mode=="edit",
    outletOrgDataId:initialData?.OutletOrgDataId,
    params:{
      outletOrgNoteId: initialData?.OutletOrgNoteId
    }
  })

  useEffect(() => {
  if (mode === "edit" && getNoteById?.data?.OutletOrgNote) {
    const data = getNoteById?.data?.OutletOrgNote;

    setDate(data?.NoteDate || "");
    setNote(data?.Note || "");
    setTitle(data?.NoteTitle || "");
    
  
  }
}, [getNoteById, mode]);



const{mutate:addNote}=useAddOutletOrgNote()
const {mutate:updateNote}=useUpdateOutletOrgNote()





const handleSubmit=(e: React.FormEvent)=>{
  e.preventDefault();

  const payload:any = {
    noteDate:date,
    noteTitle: title,
    note:note
  };
  // console.log('payload',payload)
 if (mode === "edit") {
    payload.outletOrgNoteId = initialData?.OutletOrgNoteId;
    updateNote(
      {
        id:initialData?.OutletOrgDataId,
        body: payload,
      },
      {
        onSuccess: () => modalClose(),
        onError: (err) => {
          console.error(err);
        },
      }
    );
  }else {
    addNote( {
        id:initialData?.OutletOrgDataId,
        body: payload,
      }, {
      onSuccess: () => modalClose(),
      onError: (err) => {
        console.error(err);
      },
    });
  }
}


  return (
    <form onSubmit={handleSubmit}>
      <div className="container-fluid">
        <div className="col">
          <label style={{ fontWeight: "500", marginTop: "8px" }}>Date</label>
          <input
            type="date"
            className="form-control"
            placeholder="Enter Date"
            value={date}
            onChange={(e: any) => setDate(e.target.value)}
          />
        </div>

        <div className="col">
          <label style={{ fontWeight: "500", marginTop: "8px" }}>
            Title
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Title"
            value={title}
            onChange={(e: any) => setTitle(e.target.value)}
          />
        </div>

    
          <div className="col">
            <label style={{ fontWeight: "500", marginTop: "8px" }}>Note</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Note"
              value={note}
             onChange={(e:any)=>setNote(e.target.value)}
            />
          </div>

        {/* Buttons */}
        <div className="d-flex justify-content-start gap-2 mt-2">
          <Btn
            style={{ backgroundColor: "#43B9B2", color: "white" }}
            type="submit"
          >
            {mode === "add" ? "Submit" : "Update"}
          </Btn>
          <Btn
            type="button"
            onClick={modalClose}
            style={{ backgroundColor: "#F9FAFC", color: "#000" }}
          >
            Cancel
          </Btn>
        </div>
      </div>
    </form>
  );
};

export default InternalNoteModal;
